import { Button, Stack } from '@mui/material'
import { supabaseApi } from '~/supabase/api'
import { AgentButton } from '../agent'
import { useRole } from '~/features/auth/useRole'

export const SystemActions = () => {
  const { role } = useRole()

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
        mx: 2,
        pt: 2,
      }}
      spacing={2}
    >
      {role !== 'marketing' && <AgentButton />}
      <Button onClick={() => supabaseApi.auth.signOut()} variant="outlined">
        Log out
      </Button>
    </Stack>
  )
}
